import { Box, Button, Dialog, DialogContent, DialogTitle, Slide, Stack, TextField } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { useSnackbar } from "notistack";
import React, { ReactElement } from "react";
import { ApiError } from "../../Api/ApiError";
import { EditStorePassword } from "../../Api/Store";
import LabelItem from "../atoms/LabelItem";


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />
})

export interface StorePasswordEditDialogProps {
    storeId?: number
    onClose: (isEdit: boolean) => void
}

const StorePasswordEditDialog: React.FC<StorePasswordEditDialogProps> = ({
    storeId,
    onClose,
}) => {
    let { enqueueSnackbar } = useSnackbar()

    const [open, setOpen] = React.useState<boolean>(false)
    const [oldPassword, setOldPassword] = React.useState<string>("")
    const [newPassword, setNewPassword] = React.useState<string>("")
    const [confirmPassword, setConfirmPassword] = React.useState<string>("")

    const abortController = React.useMemo(() => new AbortController(), [])

    React.useEffect(() => {
        return () => {
            abortController.abort()
        }
    }, [abortController])

    const doChangePassword = React.useCallback(() => {
        if( newPassword === confirmPassword && oldPassword.length>0 && newPassword.length>0 ) {
            if( storeId ) {
                EditStorePassword({
                    str_id: storeId,
                    old_str_login_pass: oldPassword,
                    new_str_login_pass: newPassword
                }, {signal: abortController.signal}).then(() => {
                    enqueueSnackbar("パスワードを変更しました", { variant: "success" })
                }).catch((e: any) => {
                    if( e.__CANCEL__ ) {
                        console.info("canceled")
                    } else if (e instanceof ApiError) {
                        enqueueSnackbar(e.message, { variant: "error" })
                    } else if (e instanceof Error) {
                        enqueueSnackbar(e.message, { variant: "error" })
                    }else {
                        enqueueSnackbar("通信に失敗しました", { variant: "error" })
                    }
                })
            }
        } else {
            enqueueSnackbar("パスワードが一致しません", {variant: "error"})
        }
    }, [abortController, storeId, oldPassword, newPassword, confirmPassword, enqueueSnackbar])

    React.useEffect(() => {
        setOpen(false)
        if( storeId ) {
            setOldPassword("")
            setNewPassword("")
            setConfirmPassword("")
            setOpen(true)
        }
    }, [storeId])
    
    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            onClose={() => {
                onClose(false)
            }}
            fullWidth
        >
            <DialogTitle>ログインパスワードを変更</DialogTitle>
            <DialogContent>
                <Box component="form" onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
                    e.preventDefault()
                    doChangePassword()
                }} noValidate>
                    <Stack
                        sx={{
                            mb: 2
                        }}
                        spacing={2}
                    >
                        <LabelItem
                            title="現在のパスワード"
                        >
                            <TextField
                                variant="standard"
                                value={oldPassword}
                                fullWidth
                                type="password"
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setOldPassword(e.target.value)
                                }}
                            />
                        </LabelItem>
                        <LabelItem
                            title="新しいパスワード"
                        >
                            <TextField
                                variant="standard"
                                value={newPassword}
                                fullWidth
                                type="password"
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setNewPassword(e.target.value)
                                }}
                            />
                        </LabelItem>
                        <LabelItem
                            title="新しいパスワード（再入力）"
                        >
                            <TextField
                                variant="standard"
                                value={confirmPassword}
                                fullWidth
                                type="password"
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setConfirmPassword(e.target.value)
                                }}
                            />
                        </LabelItem>
                    </Stack>
                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                    >
                        <Button
                            variant="outlined"
                            type="submit"
                        >変更を実行</Button>
                    </Stack>
                </Box>
            </DialogContent>
        </Dialog>
    );
}

export default StorePasswordEditDialog